module.exports = __webpack_public_path__ + "fonts/Flaticon.5be3e43c.woff";